import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ARCHIVE_ENTRIES, LAUNCH_SHORT } from "../data/prelaunch";
import { Reveal } from "./Reveal";

const Entry = ({ e, i }) => {
  const [notYet, setNotYet] = useState(false);
  return (
    <Reveal delay={i * 0.08}>
      <article data-testid={`archive-entry-${e.slug}`}>
        <Link
          to={`/archive/${e.slug}`}
          onMouseEnter={() => setNotYet(true)}
          onMouseLeave={() => setNotYet(false)}
          className="group block"
          data-testid={`archive-link-${e.slug}`}
        >
          <div className="relative overflow-hidden aspect-[4/5] bg-[#0C0C0F]">
            <img
              src={e.fragment}
              alt={e.fragmentAlt}
              loading="lazy"
              style={{ objectPosition: e.position }}
              className="absolute inset-0 w-full h-full object-cover scale-[2.2] opacity-60 [filter:grayscale(1)_brightness(0.45)_contrast(1.2)] transition-all duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[2.05] group-hover:opacity-80"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-bds-bg via-transparent to-bds-bg/40" />
            <span className="absolute top-5 left-5 font-mono-bds text-[11px] tracking-[0.3em] text-bds-fg/60">
              {e.number}
            </span>
            <span className="absolute top-5 right-5 font-mono-bds text-[10px] uppercase tracking-[0.3em] text-bds-accent/80">
              {e.status}
            </span>
            <motion.span
              initial={false}
              animate={{ opacity: notYet ? 1 : 0 }}
              transition={{ duration: 0.5 }}
              className="absolute inset-0 grid place-items-center font-serif-display italic text-3xl md:text-4xl text-bds-cream/90"
            >
              Not yet.
            </motion.span>
          </div>
          <div className="mt-6">
            <h3 className="font-serif-display text-3xl md:text-4xl tracking-tight">{e.title}</h3>
            <p className="font-grotesk text-sm text-bds-muted mt-3 leading-relaxed max-w-xs">{e.line}</p>
            <p className="font-mono-bds text-[10px] uppercase tracking-[0.3em] text-bds-muted mt-4 group-hover:text-bds-fg transition-colors">
              Open the record →
            </p>
          </div>
        </Link>
      </article>
    </Reveal>
  );
};

export const ChapterTeaser = () => (
  <section id="chapter-i" data-testid="chapter-teaser" className="relative py-28 md:py-44 border-t border-bds-border">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12">
      <Reveal>
        <div className="flex items-baseline gap-4 mb-6">
          <span className="font-mono-bds text-xs uppercase tracking-[0.3em] text-bds-accent">BDS Archive</span>
          <span className="flex-1 h-px bg-bds-border" />
          <span className="font-mono-bds text-xs tracking-[0.3em] text-bds-muted">{LAUNCH_SHORT}</span>
        </div>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-serif-display font-light text-6xl md:text-8xl lg:text-9xl tracking-tighter leading-[0.85]">
          Chapter <span className="italic">I</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="font-grotesk text-base md:text-lg text-bds-muted leading-relaxed mt-8 mb-4 max-w-md">
          Three works. Three hundred pieces. One beginning.
        </p>
      </Reveal>
      <Reveal delay={0.14}>
        <p className="font-mono-bds text-[11px] uppercase tracking-[0.3em] text-bds-muted mb-16 md:mb-24">
          Wear the weight — 26 November 2026
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 md:gap-8">
        {ARCHIVE_ENTRIES.map((e, i) => (
          <Entry key={e.slug} e={e} i={i} />
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-16 md:mt-24">
          <Link
            to="/chapter-i"
            data-testid="chapter-i-page-link"
            className="font-mono-bds text-xs uppercase tracking-[0.25em] text-bds-muted hover:text-bds-fg border-b border-bds-border hover:border-bds-fg pb-1 transition-colors"
          >
            Read Chapter I →
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
